// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"e4c48943","182":"9d3ad3df","313":"1b1ce2de","350":"9fc8f990","453":"7c895942","736":"1a5749e2","796":"ee24728b","979":"a7ea2383"}[chunkId] + ".chunk.js";
};